/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ErrorOutput,
  TtsInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create TTS redirect
 */
export const createAiTts = (
    ttsInput?: MaybeRefOrGetter<TtsInput>,
 signal?: AbortSignal
) => {
      ttsInput = toValue(ttsInput);

      return axiosClient<void>(
      {url: `/ai/tts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ttsInput, signal
    },
      );
    }




export const getCreateAiTtsMutationKey = () => ['createAiTts'] as const;

export const getCreateAiTtsMutationOptions = <TError = ErrorType<void | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiTts>>, TError,CreateAiTtsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiTts>>, TError,CreateAiTtsMutationVariables, TContext> => {

const mutationKey = getCreateAiTtsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiTts>>, CreateAiTtsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiTts(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiTtsMutationResult = NonNullable<Awaited<ReturnType<typeof createAiTts>>>
    export type CreateAiTtsMutationBody = TtsInput | undefined
    export type CreateAiTtsMutationError = ErrorType<void | ErrorOutput>
    export type CreateAiTtsMutationVariables = {data?: TtsInput}

    /**
 * @summary Create TTS redirect
 */
export const useCreateAiTts = <TError = ErrorType<void | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiTts>>, TError,CreateAiTtsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiTts>>,
        TError,
        CreateAiTtsMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiTtsMutationOptions(options), queryClient);
    }
